import { dv } from '../i18n/dv.ts';

export interface RegisterPreviewTableProps {
  columnLabels: string[];
  rows: string[][];
}

export function RegisterPreviewTable({ columnLabels, rows }: RegisterPreviewTableProps): JSX.Element {
  if (rows.length === 0) {
    return (
      <p className="card-paper p-6 text-center text-sm text-muted-foreground">
        {dv.dhaftharu.noPreviewRows}
      </p>
    );
  }

  return (
    <div className="card-paper overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-border bg-muted/20">
            <th className="mono-meta px-3 py-2 text-start text-muted-foreground w-8">#</th>
            {columnLabels.map((label, i) => (
              <th key={i} className="px-3 py-2 text-start font-medium whitespace-nowrap">
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {rows.map((row, i) => (
            <tr key={i} className="hover:bg-muted/10">
              <td className="mono-meta px-3 py-2 text-muted-foreground tabular">{i + 1}</td>
              {row.map((cell, j) => (
                <td key={j} className="px-3 py-2 text-foreground">
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
